export default function Ractive$toHTML () {
	return this.fragment.toString( true );
}
